import { TenantTable } from "@/components/datatables/tenants/Tenants.table.tsx";
export const TenantsPage = () => {
  return (
    <div className="flex flex-grow items-center justify-center">
      <TenantTable />
    </div>
  );
};
